import beaconLogo from 'assets/BeaconLogo.svg';

import { AuthModel } from 'Pages/FigmaPluginAuth/components/AuthModel';

import styles from './styles.module.scss';

export const JiraAuthComplete = () => (
  <AuthModel
    icons={<img src={beaconLogo} alt="onBeacon Logo" className={styles['icon']} />}
    title="You're all set!"
    description="Return to Figma and start importing your Jira tasks into onBeacon."
  />
);
